import React, { useCallback } from 'react';
import { getContact, listContactsByAgent } from '../../api/contacts';
import { getContactAdmin, listContactsAdmin } from '../../api/contactsAdmin';
import AsyncSearchSelect from '../ui/AsyncSearchSelect';

function ContactSearchSelect({
  id = 'contact-search',
  value,
  onChange,
  agentId,
  mode = 'user',
  label = 'Contato',
  disabled = false,
  placeholder = 'Buscar contato...',
  layout = 'stacked',
}) {
  const isDisabled = disabled || !agentId;

  const loadOptions = useCallback(
    async (search) => {
      if (!agentId) {
        return [];
      }

      const response =
        mode === 'admin'
          ? await listContactsAdmin({
              page: 1,
              perPage: 20,
              agentId,
              search: search || undefined,
            })
          : await listContactsByAgent(agentId, {
              page: 1,
              perPage: 20,
              search: search || undefined,
            });

      return (response.data || []).map((contact) => ({
        value: contact.id,
        label: contact.external_id,
      }));
    },
    [agentId, mode]
  );

  const resolveOption = useCallback(
    async (contactId) => {
      const contact =
        mode === 'admin' ? await getContactAdmin(contactId) : await getContact(contactId);
      return {
        value: contact.id,
        label: contact.external_id,
      };
    },
    [mode]
  );

  return (
    <AsyncSearchSelect
      id={id}
      value={value}
      onChange={onChange}
      loadOptions={loadOptions}
      resolveOption={resolveOption}
      allowEmpty
      emptyLabel={
        !agentId
          ? 'Selecione um agente primeiro'
          : 'Selecione um contato'
      }
      disabled={isDisabled}
      placeholder={placeholder}
      layout={layout}
      label={label}
    />
  );
}

export default ContactSearchSelect;
